/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { keyedProviderDataReviewTypeOptions } from 'app/core/options/provider-data-review-type.opts';

@Component({
    selector: '[app-audit-provider-data-review-update-row]',
    templateUrl: './audit-provider-data-review-update-row.component.html',
    styleUrls: ['./audit-provider-data-review-update-row.component.scss'],
    imports: [DatePipe, BlankValueDashPipe]
})
export class AuditProviderDataReviewUpdateRowComponent implements OnInit {
  @Input() audit: Audit;
  newValueHtml;
  previousValueHtml;

  keyedProviderDataReviewTypeOptions = keyedProviderDataReviewTypeOptions;

  constructor() {}

  ngOnInit() {
    const newValues = {};
    const previousValues = {};

    for(const [key, value] of Object.entries(this.audit.auditedChanges)) {
      newValues[key] = value[1] || '--';
      previousValues[key] = value[0] || '--';
    }

    this.newValueHtml = obj2Html(newValues);
    this.previousValueHtml = obj2Html(previousValues);
  }
}